module.exports = __webpack_public_path__ + "img/3_icn_tshirt.9c580136.png";